import { render } from "./Vod.vue?vue&type=template&id=1e532bb4"
import script from "./Vod.vue?vue&type=script&lang=js"
export * from "./Vod.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__